function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.426 17.574c-23.431-23.432-61.42-23.432-84.852 0-23.432 23.431-23.432 61.42 0 84.852 23.431 23.432 61.42 23.432 84.852 0 23.432-23.431 23.432-61.42 0-84.852zM83.031 36.968c-12.72-12.72-33.343-12.72-46.063 0-12.72 12.72-12.72 33.343 0 46.063 12.72 12.72 33.343 12.72 46.063 0 12.72-12.72 12.72-33.343 0-46.063z",
  fill: "#FFAA9A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.574 102.427c23.431 23.431 61.421 23.431 84.852 0 23.432-23.432 23.432-61.422 0-84.853L83.032 36.969c12.72 12.72 12.72 33.343 0 46.063-12.72 12.72-33.343 12.72-46.063 0l-19.395 19.395z",
  fill: "#FF8169"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.426 17.574c-23.431-23.432-61.42-23.432-84.852 0-23.432 23.431-23.432 61.42 0 84.852 23.431 23.432 61.42 23.432 84.852 0 23.432-23.431 23.432-61.42 0-84.852zM83.031 36.968c-12.72-12.72-33.343-12.72-46.063 0-12.72 12.72-12.72 33.343 0 46.063 12.72 12.72 33.343 12.72 46.063 0 12.72-12.72 12.72-33.343 0-46.063z",
  fill: "#D9D9D9"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#help-lifeline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.472 111.356l-1.351-1.355 24.244-24.244 3.03 3.03-25.923 22.569z",
  fill: "#FFE48D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.12 110.002L9.743 97.627l21.467-27.02 15.152 15.152-24.244 24.243z",
  fill: "#FFEDB2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.547 48.636l-3.03-3.03 24.243-24.244 1.012 1.01-22.225 26.264z",
  fill: "#FFE48D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.516 45.605L71.364 30.453l27.187-21.3 12.209 12.209-24.244 24.244zM7.73 21.356l13.221-13.22 26.928 21.56L29.696 47.88 7.731 21.356z",
  fill: "#FFEDB2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.364 89.547l18.183-18.182 22.317 26.17-12.712 12.711-27.788-20.699z",
  fill: "#FFE48D"
}));

const SvgHelpLifeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  fill: "none"
}, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "help-lifeline_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 120,
  height: 120
}, _ref3), _ref4);

export default SvgHelpLifeline;